import { CatalogFactory } from "@/v2/models/catalog.js";
import httpMixin from "@/v2/mixins/http.js";
export default {
    mixins: [httpMixin],
    methods: {
        _catalogMapper(catalog) {
            return {
                id: catalog.id,
                name: catalog.name,
            };
        },

        parseCatalog(catalog) {
            return CatalogFactory.construct(
                this._notificationMapper,
                catalog
            );
        },

        getCatalog(name, url, payload, success, failure) {
            return this.getData(
                url + '/' + name,
                payload,
                (response) => {
                    success(this.parseCatalog(response.data));
                },
                failure
            );
        },
    }
};
